// src/views/adminView/contractsView/contractSearch.js
// Búsqueda de empresas del Directorio sobre la cartera ya cargada en el cliente.
//
// Aplica el mismo criterio que la búsqueda del servidor
// (microservice-contracts, contracts.service.ts, ContractsService.findAll, paso
// "Búsqueda dinámica multi-campo y multi-término"). La lista paginada se
// resuelve allá, pero con un orden o un filtro activo la vista trabaja sobre la
// cartera completa, y el KPI "Pedidos últimos 30 días" suma sobre esa cartera en
// cuanto hay una búsqueda: si los dos criterios difieren, el mismo texto da
// empresas distintas según haya o no un orden aplicado, y la lista y el KPI se
// contradicen.
//
// Por eso NO se usa matchCommerce (utils/commerceSearch.js): es mejor buscador
// (pliega tildes y encuentra el RUT sin puntos), pero al ser distinto del
// servidor rompería esa paridad. Límite conocido y aceptado: ningún modo pliega
// tildes.

// Campos de `contract.companyId` en los que busca el servidor.
const SEARCHABLE_FIELDS = ['businessIdentifier', 'name', 'fiscalAddress', 'legalName'];

/**
 * ¿La empresa del contrato coincide con lo escrito en el buscador?
 *
 * El texto se parte por espacios y CADA término —literal, sin distinguir
 * mayúsculas— debe estar contenido en al menos uno de los campos buscables
 * (no hace falta que sea el mismo campo para todos). Búsqueda vacía o solo
 * espacios = coincide.
 *
 * @param {{ companyId?: object | null } | null | undefined} contract
 * @param {string} searchTerm texto tal como lo escribió el usuario
 * @returns {boolean}
 */
export function contractMatchesSearch(contract, searchTerm) {
  const query = String(searchTerm ?? '').trim().toLowerCase();
  if (!query) return true;

  const company = contract?.companyId;
  // Solo cuentan los strings: el schema de la empresa (microservice-contracts,
  // company.schema.ts) declara los 4 campos como string, así que cualquier otro
  // valor es un dato anómalo y se descarta en vez de convertirlo a texto.
  const texts = SEARCHABLE_FIELDS.map((field) => company?.[field])
    .filter((value) => typeof value === 'string')
    .map((value) => value.toLowerCase());

  return query.split(/\s+/).every((term) => texts.some((text) => text.includes(term)));
}
